import './version';
export { WindowContext, WindowProvider, useDocument, useWindow } from '@fluentui/react-window-provider';
//# sourceMappingURL=WindowProvider.js.map